import { render, staticRenderFns } from "./AddNomineeDetails.vue?vue&type=template&id=1ae23ab6"
import script from "./AddNomineeDetails.vue?vue&type=script&lang=js"
export * from "./AddNomineeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports